module.exports = __webpack_public_path__ + "static/hpe-fd5fef49502b3d6b7a85f40f978be85f.png";